/** @jsx jsx */
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'
import InstagramPost from '~/components/Generic/InstagramPost'

const InstagramSection = ({ posts, subtitle, title }) => {
  return (
    <Box bg="backgroundLight" pt={[6, 7, null, 9]} pb={[7, 8, null, 10]}>
      <Container sx={{ textAlign: 'center' }}>
        <Heading as="h2" variant="title2">
          {title}
        </Heading>
        <Heading as="h3" variant="subtitle1" mt={2}>
          {subtitle}
        </Heading>
        <Grid columns={[2, 3, 6]} mt={[5, 6]}>
          {posts.map((post, index) => {
            return <InstagramPost key={index} post={post} />
          })}
        </Grid>
      </Container>
    </Box>
  )
}

export default InstagramSection
